import trackingService from "./tracking";

export type DashboardViewedData = {
  user_id?: string;
};

export function trackDashboardViewed(props: DashboardViewedData): void {
  trackingService.track({
    type: "Dashboard Viewed",

    data: {
      dashboard_name: "Sherlock",
      timestamp: new Date(),
      ...props,
    },
  });
}

export type DateRangeSelectedData = {
  start_date: Date | string;
  end_date: Date | string;
  user_id?: string;
};

export function trackDateRangeSelected(props: DateRangeSelectedData): void {
  trackingService.track({
    type: "Date Range Selected",

    data: {
      dashboard_name: "Sherlock",
      timestamp: new Date(),
      ...props,
    },
  });
}

export type CampaignSelectedData = {
  organization: string;
  campaign_id: string;
  user_id?: string;
};

export function trackCampaignSelected(props: CampaignSelectedData): void {
  trackingService.track({
    type: "Campaign Selected",

    data: {
      dashboard_name: "Sherlock",
      timestamp: new Date(),
      ...props,
    },
  });
}

export type MetricSelectedData = {
  metric_name: string;
  user_id?: string;
};

export function trackMetricSelected(props: MetricSelectedData): void {
  trackingService.track({
    type: "Metric Selected",

    data: {
      dashboard_name: "Sherlock",
      timestamp: new Date(),
      ...props,
    },
  });
}

export type ChangeFilterAppliedData = {
  filter_name: string;
  filter_state: boolean;
  user_id?: string;
};

export function trackChangeFilterApplied(props: ChangeFilterAppliedData): void {
  trackingService.track({
    type: "Change Filter Applied",

    data: {
      dashboard_name: "Sherlock",
      timestamp: new Date(),
      ...props,
    },
  });
}

export type ChartTooltipViewedData = {
  timestamp_hovered: Date | string;
  actual_value?: number | string;
  predicted_value?: number | string;
  user_id?: string;
};

export function trackChartTooltipViewed(props: ChartTooltipViewedData): void {
  trackingService.track({
    type: "Chart Tooltip Viewed",

    data: {
      dashboard_name: "Sherlock",
      timestamp: new Date(),
      ...props,
    },
  });
}

export type SherlockImpactMessageDisplayedData = {
  message_text: string;
  user_id?: string;
};

export function trackSherlockImpactMessageDisplayed(props: SherlockImpactMessageDisplayedData): void {
  trackingService.track({
    type: "Sherlock Impact Message Displayed",

    data: {
      dashboard_name: "Sherlock",
      timestamp: new Date(),
      ...props,
    },
  });
}
